import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme';
import { HashRouter } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';
import { MenuProvider } from './providers/MenuProvider';

// declare module '@mui/styles/defaultTheme' {
//   // eslint-disable-next-line @typescript-eslint/no-empty-interface
//   interface DefaultTheme extends Theme {}
// }

interface ProvidersProps {
  children: React.ReactNode;
}

export default function Providers({ children }: ProvidersProps) {
  return (
    <HashRouter>
      <MenuProvider>
        <SnackbarProvider
          maxSnack={5}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
          <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme}>
              <CssBaseline />
              {children}
            </ThemeProvider>
          </StyledEngineProvider>
        </SnackbarProvider>
      </MenuProvider>
    </HashRouter>
  );
}
